import Vue from 'vue'
import App from './App.vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import SwiperClass, { Navigation, Pagination, Controller, EffectFade /* add some modules if you need */ } from "swiper";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueScrollTo from 'vue-scrollto'
import vSelect from 'vue-select'
import InputMask from 'vue-input-mask';
import VBodyScrollLock from 'v-body-scroll-lock'
import VueGeolocation from 'vue-browser-geolocation';
import {store} from './store'
import router from './router'
import browserDetect from "vue-browser-detect-plugin";
import VueGtm from '@gtm-support/vue2-gtm';

import './style/normalize.scss'
import './style/fonts.scss'
import './style/global.scss'
import 'swiper/swiper-bundle.css'
import 'vue-select/dist/vue-select.css'

// Transpiler for older browsers
import 'core-js/stable';
// optional but required for transforming generator fns.
import 'regenerator-runtime/runtime';

Vue.use(browserDetect);

Vue.component('v-select', vSelect)
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -100,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
Vue.component('input-mask', InputMask)
Vue.use(VueGeolocation);

Vue.use(VueGtm, {
  id: 'GTM-4S9T',
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: false, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [''], // Don't trigger events for specified router names (case insensitive) (optional)
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
});


SwiperClass.use([Navigation, Pagination, Controller, EffectFade]);


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCZAwBCkM5E2FBM41A8L5e5D1qMUVSDqik',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    region: 'RU',
    language: 'ru',
  },
  installComponents: true
})
Vue.use(VBodyScrollLock)
Vue.use(VueAwesomeSwiper, {})
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  store: store,
  router,
}).$mount('#app')
